import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  all: [],
};

const slice = createSlice({
  name: "books",
  initialState,

  reducers: {
    setBooks: (state, action) => {
      state.all = action.payload;
    },
  },
});
export const { setBooks } = slice.actions;
export default slice.reducer;
